// Правилото като равенство в един ред чипове: [1 кг Кафе A] = [0.7 кг Кафе B].
// Същото изречение като картите в редактора — ползва се в реда на списъка, в
// празното му състояние и в редактора преди да има продукти (примерът
// `InterchangeRuleExample`).
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { highlightWords } from "../../components/highlight";
import { formatAmount, type InterchangeChainLink } from "./interchangeablesShared";

type Props = {
  links: InterchangeChainLink[];
  // думите от търсачката на списъка — оцветяват се в имената
  searchWords?: string[];
};

export const InterchangeChainChips = ({ links, searchWords = [] }: Props) => (
  <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-2">
    {links.map((link, index) => (
      <Fragment key={`${link.productId}-${index}`}>
        {index > 0 && (
          <span aria-hidden="true" className="shrink-0 font-sheet text-sm font-bold text-faint">
            =
          </span>
        )}
        <span className="inline-flex min-w-0 items-baseline gap-1.5 rounded-[9px] border border-shade-3 bg-surface px-3 py-[7px]">
          <span className="font-sheet text-[13.5px] font-bold leading-[normal] text-brand-deep-ink">
            {link.amount != null ? formatAmount(link.amount) : "?"}
          </span>
          {link.unit && (
            <span className="text-[11.5px] leading-[normal] text-muted">{link.unit}</span>
          )}
          <span className="truncate text-[13.5px] font-semibold leading-[normal] text-ink">
            {highlightWords(link.productName, searchWords)}
          </span>
        </span>
      </Fragment>
    ))}
  </div>
);

// Примерът „1 кг Кафе A = 0.7 кг Кафе B → ако липсват 10 кг Кафе A, се
// предлагат 7 кг Кафе B" — обяснява какво е правило, докато още няма нито едно
// (празният списък) или докато в редактора няма 2 продукта.
export const InterchangeRuleExample = ({ className = "" }: { className?: string }) => {
  const { t } = useTranslation();
  const unit = t("inventoryPage.ichExampleUnit");
  const productA = t("inventoryPage.ichExampleA");
  const productB = t("inventoryPage.ichExampleB");
  return (
    <div className={`flex flex-col gap-2.5 rounded-[10px] border border-dashed border-shade-3 px-3.5 py-3 text-left ${className}`}>
      <span className="text-[10.5px] font-semibold uppercase leading-[normal] tracking-[0.08em] text-muted">
        {t("inventoryPage.ichExampleLabel")}
      </span>
      <InterchangeChainChips
        links={[
          { productId: -1, productName: productA, unit, amount: 1 },
          { productId: -2, productName: productB, unit, amount: 0.7 },
        ]}
      />
      <p className="m-0 text-[12.5px] leading-[1.45] text-body">
        {t("inventoryPage.ichExampleScenario", { unit, a: productA, b: productB })}
      </p>
    </div>
  );
};

export default InterchangeChainChips;
